<template>
  <div class="patents">
    <div class="input-box">
      <div class="label"><a-icon type="search" /></div>
      <input type="text" placeholder="请输入 公开授权号/发明人/高校申请人" v-model="form.publicNo" @change="change">
      <div class="btn" @click="search">专利查询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatentSearch",
  data() {
    return {
      form: {
        publicNo: "",
        inventor: "",
        collegeApplicant: ""
      }
    }
  },
  methods: {
    search() {
      // this.$router.push('/patent')
      // console.log(this.form)
      this.$router.push({ name: 'advancedsearchls', query: { search: this.form, index: 1 } })
    },
    change() {
      this.form.collegeApplicant = this.form.inventor = this.form.publicNo
      // this.form.collegeApplicant = this.form.publicNo
      // console.log(this.form)
    }
  }

}
</script>

<style lang="scss" scoped>
.patents {
  // height: 320px;
  // background-image: url('@/assets/img/bannerbg.png');
  // background-position: 50% 50%;
  position: relative;
  top: -60px;

  .input-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    width: 900px;
    height: 50px;
    background-color: #fff;
    // border-radius: 30px;
    align-items: center;
    padding: 10px 0 10px 0;
    border-radius: 4px;
    border: 1px solid #003A80;

    .label {
      width: 40px;
      height: 40px;
      // border-radius: 30px;
      // border: 1px solid #ccc;
      // background-color: #eee;
      font-size: $size-h2;
      line-height: 40px;
      text-align: center;
    }

    input {
      flex: 1 1 auto;
      height: 100%;
      font-size: $size-text;
      margin-left: 10px;
    }

    .btn {
      width: 90px;
      height: 50px;
      background-color: #003A80;
      // border-radius: 4px;
      // background-image: url('@/assets/img/ptsearch.png');
      // background-position: 50% 50%;
      cursor: pointer;
      font-size: 18px;
      color: #FFFFFF;
      letter-spacing: 1px;
      text-align: center;
      line-height: 50px;
    }
  }
}
</style>